// extracted by css-extract-rspack-plugin
export default {"container":"agentic-suggestions__container___RvP65","circularLoader":"agentic-suggestions__circularLoader___fQ6HR"};